__turbopack_context__.v({
  "app": "page-module__IxS6Vq__app",
  "blocklyContainer": "page-module__IxS6Vq__blocklyContainer",
  "canvasWrapper": "page-module__IxS6Vq__canvasWrapper",
  "commander": "page-module__IxS6Vq__commander",
  "console": "page-module__IxS6Vq__console",
  "consoleWrapper": "page-module__IxS6Vq__consoleWrapper",
  "customScrollbar": "page-module__IxS6Vq__customScrollbar",
  "editorButton": "page-module__IxS6Vq__editorButton",
  "header": "page-module__IxS6Vq__header",
  "output": "page-module__IxS6Vq__output",
  "outputControlContainer": "page-module__IxS6Vq__outputControlContainer",
  "outputPane": "page-module__IxS6Vq__outputPane",
  "outputWrapper": "page-module__IxS6Vq__outputWrapper",
  "pageContainer": "page-module__IxS6Vq__pageContainer",
  "splitter": "page-module__IxS6Vq__splitter",
  "splitterRow": "page-module__IxS6Vq__splitterRow",
  "title": "page-module__IxS6Vq__title",
  "workspace": "page-module__IxS6Vq__workspace",
  "zoomWrapper": "page-module__IxS6Vq__zoomWrapper",
});
